import React, { useRef, useState } from 'react';
import _get from 'lodash/get';
import { intlFormatDistance } from 'date-fns';
import { IconButton, Typography, makeStyles } from '@material-ui/core';
import { replacePlaceholders } from 'utils/stringUtils';
import { CheckIcon } from 'containers/Series/components/icons/CheckIcon';
import { PencilIcon } from './icons/Pencil';

const useStyles = makeStyles({
  reflectionItem: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    borderRadius: 8,
    backgroundColor: '#F4FAFF',
    margin: props => (props.small ? '20px 0px 0px' : '20px 0px 0px 20px'),
    width: props => (props.small ? '100%' : 'calc(50% - 10px)'),

    '& p': {
      marginTop: 0,
      marginBottom: 0,
    },

    '&:first-child, &:nth-child(3)': {
      margin: '20px 0px 0px',
    },
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 20,
  },
  dateLabel: {
    color: '#A6A6A6',
    '&:first-child': {
      marginRight: 16,
    },
  },
  button: {
    position: 'absolute',
    top: -16,
    right: 0,
    border: '1px solid #E0E0E0',
    backgroundColor: '#FFF',

    '&:hover': {
      backgroundColor: 'rgba(245, 245, 245, 0.5)',
    },
  },
});

export const CoursePreviousReflection = ({
  answer,
  question,
  coursesSiteCopy,
  onAnswerChange,
  small,
}) => {
  const classes = useStyles({ small });
  const [isEditing, setIsEditing] = useState(false);
  const ref = useRef(null);

  const onEdit = () => {
    setIsEditing(true);

    const answerNode = ref.current;
    answerNode.contentEditable = 'plaintext-only';
    const range = document.createRange();
    const selection = window.getSelection();
    range.setStart(answerNode, answerNode.childNodes.length);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const onSave = () => {
    const answerNode = ref.current;
    const value = answerNode.textContent;
    answerNode.contentEditable = false;

    setIsEditing(false);
    if (value !== answer.answer) {
      onAnswerChange({ name: question.name, value, answerId: answer.id });
    }
  };

  const now = new Date();

  return (
    <div key={answer.id} className={classes.reflectionItem}>
      <Typography ref={ref} color="textPrimary">
        {answer.answer}
      </Typography>
      <div className={classes.dateContainer}>
        <Typography className={classes.dateLabel} variant="overline">
          {replacePlaceholders(_get(coursesSiteCopy, 'pageCopy.createdAt'), {
            '#date': intlFormatDistance(answer.createdAt, now),
          })}
        </Typography>
        {answer.updatedAt && (
          <Typography className={classes.dateLabel} variant="overline">
            {replacePlaceholders(_get(coursesSiteCopy, 'pageCopy.updatedAt'), {
              '#date': intlFormatDistance(answer.updatedAt, now),
            })}
          </Typography>
        )}
      </div>
      <IconButton
        className={classes.button}
        onClick={() => (isEditing ? onSave(answer.id) : onEdit(answer.id))}
      >
        {isEditing ? (
          <CheckIcon transparent width={16} height={16} />
        ) : (
          <PencilIcon />
        )}
      </IconButton>
    </div>
  );
};
